import { ProColumns } from "@ant-design/pro-components";
import { useTable } from "./useTable";
import type { ApiFunction, Search } from "./useTable";

type UseCompleteTableFn<T> = {
  fetchFn: ApiFunction;
  columns: ProColumns<T>[];
};

export function useCompleteTable<T, P>({
  fetchFn,
  columns,
}: UseCompleteTableFn<T>) {
  return useTable({
    fetchFn,
    columns,
    formatter: (rawParams: P & Search) => {
      const { current, pageSize, ...restParams } = rawParams;
      return {
        ...restParams,
      };
    },
    extractor: (res) => {
      const list = res.data ?? [];
      return {
        data: list,
        total: list.length,
      };
    },
  });
}
